import { useContext } from 'react'
import { SignalVerdict } from '../types'
import { applicationConfiguration } from 'app/modules/shared'
import { getVerdictLabel } from '../helpers'

export const useVerdictLabel = <T extends string>(
  verdict?: SignalVerdict | T,
  opts?: { custom?: Record<T, string>; capped?: 'all' | 'first-char' | 'none' }
) => {
  const { useHumanFriendlyVerdicts } = useContext(applicationConfiguration)

  if (!verdict) {
    return ''
  }

  const label = getVerdictLabel(verdict, useHumanFriendlyVerdicts, opts)
  return label
}
